const TableRowHoverPosition = {
  TOP: 'TOP',
  CENTER_TOP: 'CENTER_TOP',
  CENTER_BOTTOM: 'CENTER_BOTTOM',
  BOTTOM: 'BOTTOM'
};

export default TableRowHoverPosition;
